import React from 'react';

import Card from '@mui/joy/Card';
import Typography from '@mui/joy/Typography';
import Grid from '@mui/joy/Grid';
import Switch from '@mui/joy/Switch';
import Divider from '@mui/joy/Divider';
import CardContent from '@mui/joy/CardContent';

import {config} from "./config.js";


export default function StopCard(props) {
	const [activeCard, setActiveCard] = React.useState(false);

	
	function handleChange(event) {
		setActiveCard(event.target.checked);
		//props.handleClick(!activeCard);
	}


	return (
		
		<Card sx={{ minHeight: '220px', width: config.cardWidth, bgcolor: config.cardColor}}>
					
			<CardContent>
		        <Typography level="h2" fontSize="lg" textColor="#f0f4f8" startDecorator={props.icon} mb={1}>
					{props.title}
		        </Typography>
		        
		        <Grid container spacing={4} sx={{ flexGrow: 1 }}>
		        
		        	<Grid xs={10}>
				        <Typography textColor="neutral.300" mb={2}>
							{props.description}
				        </Typography>
				    </Grid>
				    
		        	<Grid xs={2} display = "flex" justifyContent="center" alignItems="center">
			        	<Switch checked={activeCard} onChange={(event) => {handleChange(event)}}/>
					</Grid>
		
			    </Grid>
		        
		        <Divider  sx={{mb:2}} />
		        		        
		        {React.cloneElement(React.Children.only(props.children), { activeCard: activeCard, handleClick: props.handleClick })}
		        		
			</CardContent>
		
		</Card>
		
	)
	
}